var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 85,
    viewBox: "0 0 88 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2709 52.4135C69.5275 38.5571 58.4965 27.1164 44.6325 26.86C30.7685 26.6036 19.3216 37.6286 19.0651 51.4851C18.8085 65.3415 29.8396 76.7822 43.7035 77.0386C57.5675 77.295 69.0144 66.27 69.2709 52.4135Z",
    fill: "url(#paint0_linear_3613_4301)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0316 18.6215L24.0545 10.0084C30.4427 7.47436 37.2016 6.19037 44.1706 6.19037C51.1406 6.19037 57.9017 7.47436 64.2897 10.0084L59.2809 18.6793C61.164 19.5396 62.9692 20.5564 64.6766 21.7196L73.0752 7.17992L70.0253 5.7481C61.9033 1.9341 53.2053 0 44.1706 0C35.139 0 26.441 1.9341 18.3197 5.7481L15.269 7.17992L23.6246 21.6412C25.3364 20.4848 27.1451 19.4744 29.0316 18.6215Z",
    fill: "url(#paint1_linear_3613_4301)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7217 41.4696H17.9779H18.6604C22.7818 31.4848 32.6136 24.4543 44.0922 24.4543C55.5707 24.4543 65.4027 31.4848 69.5239 41.4696H69.8822H75.4626H88.0001L74.3941 38.7086C69.2866 27.0427 57.6475 18.8859 44.0922 18.8859C30.5526 18.8859 18.9256 27.0241 13.8092 38.6675L0.000488281 41.4696H12.7217Z",
    fill: "url(#paint2_linear_3613_4301)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4623 62.4161H69.8819H69.5236C65.4024 72.4023 55.5704 79.432 44.0919 79.432C32.6133 79.432 22.7815 72.4023 18.6601 62.4161H17.9776H12.7214H0L13.8087 65.2182C18.9251 76.8628 30.5523 85.0003 44.0917 85.0003C57.647 85.0003 69.2861 76.8434 74.3936 65.1772L87.9996 62.4161H75.4623Z",
    fill: "url(#paint3_linear_3613_4301)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2225 50.5064H33.6365V44.416H30.8828V59.4676H33.6365V53.3778H54.2225V59.4676H56.9752V44.416H54.2225V50.5064Z",
    fill: "#051125"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.449 45.7095H57.6953V58.172H60.449V45.7095Z",
    fill: "#051125"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9203 47.5719H61.168V56.3111H63.9203V47.5719Z",
    fill: "#051125"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1637 45.7095H27.4102V58.172H30.1637V45.7095Z",
    fill: "#051125"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.691 47.5719H23.9385V56.3111H26.691V47.5719Z",
    fill: "#051125"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3613_4301",
    x1: 19.0651,
    y1: 51.485,
    x2: 69.2709,
    y2: 52.4145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FAADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3613_4301",
    x1: 44.2584,
    y1: -18.2807,
    x2: 43.8787,
    y2: 21.7168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C75D5",
    stopOpacity: 0.98
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3613_4301",
    x1: 83.9841,
    y1: 26.5252,
    x2: 19.21,
    y2: 41.5482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FAADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3613_4301",
    x1: -1.39682,
    y1: 59.5081,
    x2: 85.0257,
    y2: 82.0424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FAADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4285FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.925f02497a1d426b6ce6688afac51ba5.svg";
export { ForwardRef as ReactComponent };